import { render, staticRenderFns } from "./dispatch-car.vue?vue&type=template&id=c7353ec8&scoped=true"
import script from "./dispatch-car.vue?vue&type=script&lang=js"
export * from "./dispatch-car.vue?vue&type=script&lang=js"
import style0 from "./dispatch-car.vue?vue&type=style&index=0&id=c7353ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7353ec8",
  null
  
)

export default component.exports